const routes = {
  ClientDQ: '/driver-qualification/clientdq',
  CorporateDQ: '/driver-qualification/corporatedq',
};

export default routes;
